<template>
  <div>
    <div class="nk-app-root">
      <div class="nk-main">
        <div class="nk-wrap">
          <Header v-show="!loading_page" />
          <div class="nk-content">
            <div class="container wide-xl">
              <div class="nk-content-inner">
                <Navigation v-show="!loading_page" />
                <div class="nk-content-body" v-show="!loading_page">
                  <div class="nk-content-wrap">
                    <div class="nk-block nk-block-lg">
                      <div class="nk-block-head">
                        <div class="nk-block-head-content d-flex justify-content-between align-items-center">
                          <h4 class="nk-block-title">{{ $t('dm_adressen_title') }}</h4>
                          <button v-if="canDmEdit" class="btn btn-sm btn-primary" @click="openModal(null)">
                            <em class="icon ni ni-plus"></em> {{ $t('dm_adressen_btn_new') }}
                          </button>
                        </div>
                      </div>

                      <div class="form-control-wrap mb-3">
                        <input type="text" class="form-control" :placeholder="$t('dm_common_quick_filter')" v-model="quickFilterText" />
                      </div>

                      <div class="card card-bordered">
                        <div class="dm-table-wrap">
                          <table class="dm-table">
                            <colgroup>
                              <col v-for="col in tableColumns" :key="col.field" :style="col.width ? { width: col.width } : {}" />
                            </colgroup>
                            <thead>
                              <tr>
                                <th v-for="col in tableColumns" :key="col.field" @click="toggleSort(col.field)" class="dm-table-th">
                                  {{ col.label }}
                                  <span v-if="sortField === col.field" class="dm-sort-icon">{{ sortAsc ? '&#9650;' : '&#9660;' }}</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="row in filteredData" :key="row._id" @click="onRowClicked(row)" class="dm-table-row">
                                <td v-for="col in tableColumns" :key="col.field" :title="getCellValue(row, col)">{{ getCellValue(row, col) }}</td>
                              </tr>
                              <tr v-if="filteredData.length === 0">
                                <td :colspan="tableColumns.length" class="text-center text-muted py-4">{{ $t('dm_common_no_entries_found') }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal fade" tabindex="-1" id="modalAdresse">
                    <div class="modal-dialog modal-lg" role="document">
                      <div class="modal-content">
                        <a href="#" class="close" data-dismiss="modal" aria-label="Close">
                          <em class="icon ni ni-cross"></em>
                        </a>
                        <div class="modal-header">
                          <h5 class="modal-title">{{ adresseEntry._id ? $t('dm_adressen_modal_edit') : $t('dm_adressen_modal_new') }}</h5>
                        </div>
                        <div class="modal-body">
                          <div class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>
                          <div class="row gy-4">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_common_col_company') }}</label>
                                <input type="text" class="form-control" v-model="adresseEntry.firma" />
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_adressen_label_contact_person') }}</label>
                                <input type="text" class="form-control" v-model="adresseEntry.ansprechpartner" />
                              </div>
                            </div>
                          </div>
                          <div class="row gy-4 mt-2">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_common_col_street') }}</label>
                                <input type="text" class="form-control" v-model="adresseEntry.strasse" />
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_common_col_zip') }}</label>
                                <input type="text" class="form-control" v-model="adresseEntry.plz" />
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_common_col_city') }}</label>
                                <input type="text" class="form-control" v-model="adresseEntry.ort" />
                              </div>
                            </div>
                          </div>
                          <div class="row gy-4 mt-2">
                            <div class="col-sm-4">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_common_col_phone') }}</label>
                                <input type="text" class="form-control" v-model="adresseEntry.telefon" />
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_common_col_email') }}</label>
                                <input type="email" class="form-control" v-model="adresseEntry.email" />
                              </div>
                            </div>
                          </div>
                          <div class="row gy-4 mt-2">
                            <div class="col-12">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_adressen_label_roles') }}</label>
                                <div class="rolle-pills">
                                  <label v-for="r in roleOptions" :key="r.value"
                                    class="rolle-pill"
                                    :class="{ 'rolle-pill-active': adresseEntry.rollen && adresseEntry.rollen.indexOf(r.value) !== -1 }">
                                    <input type="checkbox" :value="r.value" v-model="adresseEntry.rollen" class="rolle-pill-input" />
                                    <em class="icon ni" :class="rolleIcon(r.value)"></em>
                                    {{ r.label }}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group mt-3">
                            <button type="button" class="btn btn-primary" @click="saveAdresse">
                              {{ adresseEntry._id ? $t('dm_common_btn_update') : $t('dm_common_btn_create') }}
                            </button>
                          </div>
                        </div>
                        <div class="modal-footer bg-light d-flex justify-content-between">
                          <div>
                            <button v-if="adresseEntry._id && canDmManage" type="button" class="btn btn-sm btn-outline-danger" @click="deleteAdresseAction">
                              <em class="icon ni ni-trash"></em> {{ $t('dm_common_btn_delete') }}
                            </button>
                          </div>
                          <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">{{ $t('dm_common_btn_close') }}</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../../components/Header.vue";
import Navigation from "../../../components/Navigation.vue";
import Footer from "../../../components/Footer.vue";
import dmTableMixin from "@/mixins/dm-table-mixin";
import dmPermissionsMixin from "@/mixins/dm-permissions-mixin";
import { getAdressenList, createAdresse, updateAdresse, deleteAdresse } from "@/services/dm.service";

export default {
  name: "DmAdressen",
  components: { Header, Navigation, Footer },
  mixins: [dmTableMixin, dmPermissionsMixin],
  data() {
    return {
      fullLoader: null,
      adressenList: [],
      adresseEntry: { rollen: [] },
      errorMessage: "",
    };
  },
  computed: {
    loading_page() {
      return this.$store.state.loading_page && this.$store.state.loading_page == "setup";
    },
    tableColumns() {
      return [
        { label: this.$t('dm_common_col_company'), field: "firma", width: "22%" },
        { label: this.$t('dm_adressen_label_contact_person'), field: "ansprechpartner", width: "18%" },
        { label: this.$t('dm_common_col_city'), field: "ort", width: "14%" },
        { label: this.$t('dm_common_col_email'), field: "email", width: "20%" },
        { label: this.$t('dm_common_col_phone'), field: "telefon", width: "12%" },
        { label: this.$t('dm_adressen_label_roles'), field: "rollen", width: "14%", formatter: function(val) { return val ? val.join(", ") : ""; } },
      ];
    },
    roleOptions() {
      return [
        { value: "Betreiber", label: this.$t('dm_adressen_role_operator') },
        { value: "Eigentuemer", label: this.$t('dm_adressen_role_owner') },
        { value: "Wartung", label: this.$t('dm_adressen_role_maintenance') },
        { value: "Gutachter", label: this.$t('dm_adressen_role_expert') },
        { value: "Versicherer", label: this.$t('dm_adressen_role_insurer') },
      ];
    },
    filteredData() {
      return this.filterAndSort(this.adressenList, this.tableColumns);
    },
  },
  created() {
    this.loadAdressen();
  },
  methods: {
    loadAdressen() {
      this.showLoader();
      getAdressenList()
        .then((d) => {
          this.hideLoader();
          if (d.data && d.data.list) {
            this.adressenList = d.data.list;
            this.$store.commit("set_dm_adressen", d.data.list);
          }
        })
        .catch((e) => {
          this.hideLoader();
          this.$store.dispatch("api_error", e);
        });
    },
    onRowClicked(row) {
      if (this.canDmEdit) {
        this.openModal(row);
      }
    },
    openModal(adresse) {
      this.errorMessage = "";
      this.adresseEntry = adresse ? JSON.parse(JSON.stringify(adresse)) : { rollen: [] };
      if (!this.adresseEntry.rollen) this.adresseEntry.rollen = [];
      $("#modalAdresse").modal("show");
    },
    saveAdresse() {
      this.errorMessage = "";
      if (!this.adresseEntry.firma && !this.adresseEntry.ansprechpartner) {
        this.errorMessage = this.$t('dm_adressen_error_company_or_contact_required');
        return;
      }
      if (this.adresseEntry._id) {
        updateAdresse(this.adresseEntry._id, this.adresseEntry).then((d) => {
          var err = this.getApiError(d); if (err) { this.errorMessage = err; }
          else { $("#modalAdresse").modal("hide"); this.loadAdressen(); }
        });
      } else {
        createAdresse(this.adresseEntry).then((d) => {
          var err = this.getApiError(d); if (err) { this.errorMessage = err; }
          else { $("#modalAdresse").modal("hide"); this.loadAdressen(); }
        });
      }
    },
    rolleIcon(rolle) {
      var map = {
        'Betreiber': 'ni-building',
        'Eigentuemer': 'ni-home',
        'Wartung': 'ni-setting',
        'Gutachter': 'ni-clipboard',
        'Versicherer': 'ni-shield-check',
      };
      return map[rolle] || 'ni-tag';
    },
    deleteAdresseAction() {
      this.$swal({
        title: this.$t('dm_adressen_confirm_delete_title'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: this.$t('dm_common_btn_delete_yes'),
        cancelButtonText: this.$t('dm_common_btn_cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          deleteAdresse(this.adresseEntry._id).then(() => {
            $("#modalAdresse").modal("hide");
            this.loadAdressen();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.rolle-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.rolle-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px solid var(--border-color, #E5E5E3);
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary, #555);
  background: var(--bg-surface, #fff);
  transition: all 0.15s ease;
  user-select: none;
  margin: 0;
}

.rolle-pill:hover {
  border-color: var(--accent, #E8751A);
  background: rgba(232, 117, 26, 0.04);
}

.rolle-pill-active {
  border-color: var(--accent, #E8751A);
  background: rgba(232, 117, 26, 0.08);
  color: var(--accent, #E8751A);
}

.rolle-pill-active .icon {
  color: var(--accent, #E8751A);
}

.rolle-pill .icon {
  font-size: 16px;
  color: var(--text-muted, #8C8C8C);
  transition: color 0.15s;
}

.rolle-pill-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.dm-table-wrap {
  max-height: calc(100vh - 220px);
  overflow: auto;
}

.dm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
  table-layout: fixed;
}

.dm-table th,
.dm-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dm-table thead {
  background: #f8f9fa;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 1;
}

.dm-table-th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.dm-table-th:hover {
  color: #334155;
}

.dm-sort-icon {
  font-size: 10px;
  margin-left: 4px;
  color: #E8751A;
}

.dm-table tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}

.dm-table-row {
  cursor: pointer;
  transition: background 0.15s;
}

.dm-table-row:hover {
  background: #f8fafc;
}
</style>
